import { combineReducers } from "@reduxjs/toolkit";
import { scheduleExchangeSlice, scheduleExchangeSliceName } from "./powerSlice";

export const scheduleExchangeRootSlice = combineReducers({
  [scheduleExchangeSliceName]: scheduleExchangeSlice.reducer,
});

export type ScheduleExchangeRootStateType = ReturnType<
  typeof scheduleExchangeRootSlice
>;

export * from "./powerSlice";
export * from "./power.selectors";
export * from "./power.actions";

// Aliased for routerConfig
export const sliceReducer = scheduleExchangeRootSlice;
